module.exports = __webpack_public_path__ + "media/images/stores4-03756a8a586423bf2c2e67553cd29e2d.jpg";